{
  "title": "Restablecer contraseña",
  "subtitle": "Elige una contraseña segura",
  "newPasswordLabel": "Nueva contraseña",
  "confirmPasswordLabel": "Confirmar contraseña",
  "resetButton": "Restablecer clave",
  "resettingButton": "Restableciendo...",
  "backToLogin": "Volver al inicio",
  "requirementsText": "Debe tener 8+ caracteres con mayúsculas, minúsculas y números",
  "strengthLabel": "Intensidad: {{strength}}",
  "passwordStrength": {
    "tooShort": "Muy corto",
    "weak": "Débil",
    "fair": "Bien",
    "good": "Bueno",
    "strong": "Fuerte"
  },
  "invalidLink": {
    "title": "Enlace no válido",
    "backButton": "Volver al inicio"
  },
  "errors": {
    "tooShort": "La contraseña debe tener al menos 8 caracteres",
    "needsUppercase": "La contraseña debe contener al menos una letra mayúscula",
    "needsLowercase": "La contraseña debe contener al menos una letra minúscula",
    "needsNumber": "La contraseña debe contener al menos un número",
    "noMatch": "Las contraseñas no coinciden",
    "invalidOrExpired": "Enlace de restablecimiento inválido o expirado. Por favor, solicita uno nuevo.",
    "genericError": "Ocurrió un error. Intenta de nuevo."
  }
}
